<template>
<div class='vx-col w-full mt-4'>
    <br>
    <div class="vx-row">
        <div class="vx-col md:w-1/3 sm:w-1/2 xs:w-1/1 w-full">
            <p>Puntajes:</p>
            <vs-input type="number" min="0" max="100" class="inputx w-full mb-4" v-model="datos.puntaje" maxlength="3" placeholder="puntaje" />
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 xs:w-1/1 w-full">
            <div>Incluir en la evaluación:</div>
            <vs-radio class="mt-4 mb-3 m-2" color="success" v-model="datos.evaluacion" vs-name="evaluacion" vs-value="1">Si</vs-radio>
            <vs-radio class="mt-4 mb-3 m-2" color="danger" v-model="datos.evaluacion" vs-name="evaluacion" vs-value="0">No</vs-radio>
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 xs:w-1/1 w-full">
            <div>Para repaso de estudiantes:</div>
            <vs-radio class="mt-4 mb-3 m-2" color="success" v-model="datos.repaso" vs-name="repaso" vs-value="1">Si</vs-radio>
            <vs-radio class="mt-4 mb-3 m-2" color="danger" v-model="datos.repaso" vs-name="repaso" vs-value="0">No</vs-radio>
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 xs:w-1/1 w-full" v-if="datos.estado != 2">
            <div>Estado:</div>
            <vs-radio class="mt-4 mb-3 m-2" color="success" v-model="datos.estado" vs-name="estado" vs-value="1">Activo</vs-radio>
            <vs-radio class="mt-4 mb-3 m-2" color="danger" v-model="datos.estado" vs-name="estado" vs-value="0">Inactivo</vs-radio>
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 xs:w-1/1 w-full" v-else>
            <vs-alert class="mt-5" color="warning">
                <p><i class="fa-solid fa-triangle-exclamation"></i> Pendiente opciones de respuesta</p>
            </vs-alert>
        </div>
        <!-- {{datos}} -->
    </div>
    <div class="vx-row" v-if="tipos.tp5">
        <div class="vx-col md:w-1/2 sm:w-1/2 xs:w-1/1 w-full">
            <vs-input type="text" class="inputx w-full mb-4" v-model="datos.columna1" maxlength="100" placeholder="Columna 1" label="Columna 1 (Ejm. País)" />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 xs:w-1/1 w-full">
            <vs-input type="text" class="inputx w-full mb-4" v-model="datos.columna2" maxlength="100" placeholder="Columna 2 " label="Columna 2 (Ejm. Capital)" />
        </div>
    </div>
    <div class="vx-row">
        <vx-card class='vx-col w-full'>
            <div class="vx-col w-full">
                <vs-textarea theme="full" rows="4" v-model="datos.pregunta" placeholder="Ingrese el texto de la pregunta" />
            </div>
            <div class="vx-col w-full mb-4 mt-4">
                <b class="m-3">Agregar imagen:</b>
                <FileUploadVue class="mt-5" v-model="archivoPregunta" modelName="archivoPregunta" :ObjectSelected="Object(datosEvaluacion)" :id="datos.id" :carpeta="carpeta" :pesoImagen="pesoImagen" />
                <!-- <vs-input type="file" accept="image/*" id="file-input" /> -->
            </div>
            <div class="flex justify-center">
                <vs-button icon-pack="feather" icon="icon-save" class="w-full" :color="propiedades.color_boton" @click="f_agregar_editar_pregunta()">{{propiedades.txt_boton}}</vs-button>
            </div>
        </vx-card>
    </div>
</div>
</template>

<script>
import GeneralMixin from "@/mixins/GeneralMixin.js";
const FileUploadVue = () => import("../admin/reutilizable/Files/FileUpload.vue");
const ScreenOpcionesVue = () => import("./components/Opciones/ScreenOpciones.vue");
export default {
    mixins: [GeneralMixin],
    components: {
        FileUploadVue,
        ScreenOpcionesVue,
    },
    props: {
        datosEvaluacion: {
            type: Object,
            default: () => {}
        },
        editOk: {
            type: Boolean
        },
        cabecera: {
            type: Object
        },
        tipos: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            datos: {
                id: 0,
                pregunta: '',
                resp: false,
                puntaje: 1,
                estado: 2,
                columna1: '',
                columna2: '',
                evaluacion: 1,
                repaso: 0,
            },
            propiedades: {
                color_boton: '',
                txt_boton: '',
                color_boton_opcion: '',
                txt_opciones: '',
                mensaje: '',
                color_notify: '',
            },
            opcioneditOk: '',
            arregloOpciones: [],
            datoEliminar: '',
            //variables image
            archivoPregunta: null,
            carpeta: 'preguntas',
            ObjectSelected: '',
            imgOld: '',
            //fin variables image,
            pesoImagen: 0.5,
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.f_inicio();
    },
    watch: {
        datosEvaluacion(results) {
            let me = this;
            me.f_inicio();
        },
    },
    methods: {
        f_inicio() {
            let me = this;
            // console.log('en la simple', me.editOk, me.datosEvaluacion, 'cabecera', me.cabecera)
            if (me.editOk) {
                me.propiedades = {
                    color_boton: "warning",
                    txt_boton: "Editar pregunta",
                    txt_opciones: "Editar opción",
                    color_boton_opcion: 'warning',
                }
                me.datos = {
                    id: me.datosEvaluacion.id,
                    pregunta: me.datosEvaluacion.pregunta,
                    puntaje: me.datosEvaluacion.puntaje,
                    estado: me.datosEvaluacion.estado,
                    columna1: me.datosEvaluacion.columna1,
                    columna2: me.datosEvaluacion.columna2,
                    evaluacion: me.datosEvaluacion.uso_evaluacion,
                    repaso: me.datosEvaluacion.uso_repaso,
                }
                me.imgOld = me.datosEvaluacion.url;
                // me.f_get_opciones_x_pregunta();
            } else {
                me.propiedades = {
                    color_boton: "primary",
                    txt_boton: "Guardar pregunta",
                    txt_opciones: "Guardar opción",
                    color_boton_opcion: 'success',
                }
                me.datos = {
                    id: 0,
                    pregunta: '',
                    resp: false,
                    puntaje: 1,
                    estado: 2,
                    columna1: '',
                    columna2: '',
                    evaluacion: 1,
                    repaso: 0,
                }
            }
        },
        f_agregar_editar_pregunta() {
            let me = this;
            if (me.datos.pregunta == '') {
                me.propiedades.mensaje = "Ingrese una pregunta";
                me.f_notificaciones(me.propiedades.mensaje, "warning");
                return;
            }
            if (me.datos.puntaje == '') {
                me.propiedades.mensaje = "Ingrese una puntaje";
                me.f_notificaciones(me.propiedades.mensaje, "warning");
                return;
            }
            if (me.datos.estado == '') {
                me.propiedades.mensaje = "Seleccione un estado";
                me.f_notificaciones(me.propiedades.mensaje, "warning");
                return;
            }
            if (me.tipos.tp5) {
                if (me.datos.columna1 == '' || me.datos.columna1 == null || me.datos.columna1 == undefined) {
                    me.propiedades.mensaje = "Ingrese una columna 1";
                    me.f_notificaciones(me.propiedades.mensaje, "warning");
                    return;
                }
                if (me.datos.columna2 == '' || me.datos.columna2 == null || me.datos.columna2 == undefined) {
                    me.propiedades.mensaje = "Ingrese una columna 2";
                    me.f_notificaciones(me.propiedades.mensaje, "warning");
                    return;
                }
            }
            me.$vs.loading();
            let formdatas = new FormData();
            formdatas.append('id', me.datos.id);
            formdatas.append('pregunta', me.datos.pregunta);
            formdatas.append('id_unidad_libro', me.cabecera.unidadSelect);
            formdatas.append('id_libro', me.cabecera.libroSelect);
            formdatas.append('id_tipo', me.cabecera.tipo);
            formdatas.append('puntaje', me.datos.puntaje);
            formdatas.append('estado', me.datos.estado);
            formdatas.append('columna1', me.datos.columna1 == null ? '' : me.datos.columna1);
            formdatas.append('columna2', me.datos.columna2 == null ? '' : me.datos.columna2);
            formdatas.append('solo_pregunta', 'ok'); //guardar solo pregunta
            formdatas.append('id_editor', me.cabecera.usuario);
            formdatas.append('id_grupo', me.cabecera.id_grupo);
            formdatas.append('uso_evaluacion', me.datos.evaluacion);
            formdatas.append('uso_repaso', me.datos.repaso);
            me.$http.post(this.$server_url + 'preguntas', formdatas)
                .then((res) => {
                    // console.log('retorna guardar', res.data)
                    me.guardado = true;
                    // console.log('editok', me.editOk);
                    if (me.datos.id > 0) {
                        me.propiedades.mensaje = "Pregunta editada correctamente";
                        me.propiedades.color_notify = 'success'
                    } else {
                        me.datos = res.data;
                        me.ObjectSelected = res.data;
                        // me.datos.id = res.data.id;
                        me.propiedades.mensaje = "Pregunta registrada correctamente";
                        me.propiedades.color_notify = 'success'
                        me.propiedades.color_boton = 'warning';
                        me.propiedades.txt_boton = 'Editar pregunta';
                        me.propiedades.color_boton_opcion = 'success';
                        me.propiedades.txt_opcion = 'Registrar opción';
                    }
                    me.imgOld = res.data.url;
                    me.guardarFiles(res.data.id, me.archivoPregunta);
                    me.f_notificaciones(me.propiedades.mensaje, me.propiedades.color_notify);
                    me.$vs.loading.close();
                })
                .catch(err => {
                    console.log(err)
                    me.$vs.loading.close();
                    me.propiedades.mensaje = "Error al guardar la pregunta";
                    me.f_notificaciones(me.propiedades.mensaje, me.propiedades.color_notify);
                })
        },
        guardarFiles(getId, file) {
            let me = this;
            let formData = new FormData();
            formData.append('id', getId)
            formData.append('archivo1', file)
            formData.append('imgOld', me.imgOld)
            formData.append('ruta', me.carpeta)
            //save en tabla
            //nombre modelo
            formData.append('nombreM', "Pregunta")
            formData.append('guardarTabla', "1")
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            me.$emit("change_pregunta_editada", getId);
            // console.log('simple.vue - 265')
            this.$http.post(this.$data_url + 'api/guardarDocumentos', formData, config)
                .then(() => {
                    // me.$emit("change_pregunta_editada", getId);
                }).catch(() => {});
        },

        f_vaciar_campos() {
            let me = this;
            me.datos = {
                // id: 0,
                pregunta: '',
                opcion: '',
                resp: false,
            };
        },
    }
};
</script>

<style scoped>
.boton-abajo {
    position: fixed;
    bottom: 10px;
    left: 10px;
    right: 10px;
    margin-bottom: 10px;
    z-index: 99;
}

.farchivo {
    cursor: pointer;
    color: gray;
    width: 100%;
    line-height: 80%;
    transition: 0.5 ease all;
    padding: 10px 10px;
    background-color: #e6e6f0;
    border-radius: 5px;
}

.farchivo:hover {
    background-color: #7C7B89;
    border-radius: 5px;
    color: white;
}

.borde-1 {
    border: #7C7B89 1px solid;
}
</style>
